import React from 'react';
import R from 'ramda';
import { DropDownMenu, MenuItem, FontIcon } from 'material-ui';
import AllContractsIcon from 'material-ui/svg-icons/content/select-all';

const FolderFilters = ({
  companyType,
  searchParams,
  onChange,
  folders,
  ...styles,
}) => {
  const defaultSections = companyType === 'Contractor' ? [{
    primaryText: 'Received Rates',
    queryParam: 'recent',
    icon: 'tc-icon-move_to_inbox',
  }, {
    primaryText: 'Requests Sent',
    queryParam: 'sent',
    icon: 'tc-icon-near_me',
  }] : [{
    primaryText: 'Requests',
    queryParam: 'recent',
    icon: 'tc-icon-move_to_inbox',
  }, {
    primaryText: 'Rates Sent',
    queryParam: 'sent',
    icon: 'tc-icon-near_me',
  }];
  const selectAFolder = value => () => onChange(R.merge(searchParams, { searchCategory: value, isFolder: true }));
  const selectDefault = (_, index, value) => onChange(R.merge(searchParams, { searchCategory: value }));
  return (
    <DropDownMenu
      value={searchParams.searchCategory}
      onChange={selectDefault}
      {...styles}
    >
      {
        /*
         {
         defaultSections.map((obj, i) => <MenuItem key={i} primaryText={obj.primaryText} value={obj.queryParam} leftIcon={<FontIcon className={obj.icon} />} />)
         }
         <MenuItem primaryText="All Contracts" value="all contracts" leftIcon={<FontIcon className="tc-icon-remove_red_eye" />} />
         <MenuItem primaryText="Trash" value="trash" leftIcon={<FontIcon className="tc-icon-delete2" />} />
         <MenuItem primaryText="All Contracts" value="all contracts" leftIcon={<AllContractsIcon />} />
         */
      }
      {
        folders && folders.length ? folders.map((folder, i) => {
          return (
            <MenuItem
              key={`folder${i}`}
              primaryText={folder}
              value={folder}
              onTouchTap={selectAFolder(folder)}
              label={(folder || '').substring(0, 12)}
              leftIcon={<FontIcon className="tc-icon-folder_open" />}
            />
          );
        }) : <MenuItem primaryText="You don't have any folders." disabled />
      }
    </DropDownMenu>
  );
};

export default FolderFilters;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-list/top-bar/folder-filters.jsx